import { logger } from '@belong/logging/logger';
import type { IFeatureToggles } from '../types';

class FeaturesManager {
  private values: IFeatureToggles = {};
  private isInitDone = false;

  /**
   * Only warn once per session
   * (always suppress the warning when running in Jest)
   */
  private hasWarnedAboutUsageBeforeSeeding = false;

  public init(correlationId: string, featuresMap: IFeatureToggles): void {
    logger.debug(correlationId, 'FeaturesManager::init()');
    this.values = { ...featuresMap };

    this.isInitDone = true;
  }

  public isFeatureOn(feature: string): boolean {
    if (!this.isInitDone || !this.values) {
      if (!this.hasWarnedAboutUsageBeforeSeeding) {
        logger.error('FeaturesManager.isFeatureOn used before it was seeded with any feature values!');
        this.hasWarnedAboutUsageBeforeSeeding = true;
      }

      return false;
    }

    // ensure false value if toggle isn't defined
    return this.values[feature] ?? false;
  }

  public export(): IFeatureToggles {
    return { ...this.values };
  }
}

const featuresManager = new FeaturesManager();
export default featuresManager;
